import { render, staticRenderFns } from "./TreeModal.vue?vue&type=template&id=822b54e2&scoped=true"
import script from "./TreeModal.vue?vue&type=script&lang=js"
export * from "./TreeModal.vue?vue&type=script&lang=js"
import style0 from "./TreeModal.vue?vue&type=style&index=0&id=822b54e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822b54e2",
  null
  
)

export default component.exports